import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getFlightItemsView } from 'checkout/selectors/view/flights'

type CollinsonAutoTicketMode = 'DOMESTIC' | 'INTERNATIONAL' | undefined

interface UseCollinsonAutoTicketModeParams {
  provider: string
  hasCalendar: boolean
}

function useCollinsonAutoTicketMode({
  provider,
  hasCalendar,
}: UseCollinsonAutoTicketModeParams): CollinsonAutoTicketMode {
  const flightViewsData = useAppSelector(getFlightItemsView)
  const isCollinsonNoCalendar = provider === 'cln' && !hasCalendar

  return useMemo<CollinsonAutoTicketMode>(() => {
    if (!isCollinsonNoCalendar) return undefined
    const { data: flightViews, hasRequiredData } = flightViewsData
    if (!flightViews.length) return undefined
    if (!hasRequiredData) return undefined
    const isInternational = flightViews.some(view =>
      view.flights.some(leg =>
        leg.journeyFlight.flights.some(segment =>
          segment.departingCountry !== segment.arrivalCountry,
        ),
      ),
    )
    return isInternational ? 'INTERNATIONAL' : 'DOMESTIC'
  }, [isCollinsonNoCalendar, flightViewsData])
}

export default useCollinsonAutoTicketMode
